/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const modulesFormDataInputQuestionDataTypeSchema = z.enum(['select', 'text', 'open_text', 'file', 'datetime'])

export type ModulesFormDataInputQuestionDataTypeSchema = z.infer<typeof modulesFormDataInputQuestionDataTypeSchema>
